import { render, staticRenderFns } from "./InformationBanner.vue?vue&type=template&id=586a4951&"
import script from "./InformationBanner.vue?vue&type=script&lang=ts&"
export * from "./InformationBanner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports